import type { BuildingType, PlayerRace } from '@kaeliux/shared';

/** Every `/team-planet` screen, including fleet dispatch — where the HUD and switcher show the Team planet instead of a personal one. */
export function isTeamPlanetRoute(pathname: string): boolean {
    return pathname === '/team-planet' || pathname.startsWith('/team-planet/');
}

export const RACE_LABELS: Record<PlayerRace, string> = { humans: 'Humans', robots: 'Robots', axons: 'Axons' };

/**
 * Which race's architecture each building is drawn in on the Team planet.
 * The planet is shared by every race in the alliance, so its buildings mix
 * Humans, Robots and Axons instead of all following the viewer's race —
 * spread so each zone shows all three. Keyed by building type, not plot, so
 * the surface, popover, zone list and requirement tiles always agree.
 * Explicit rather than derived from definition order, so adding a building
 * never re-skins the others.
 */
export const TEAM_PLANET_BUILDING_RACE: Record<BuildingType, PlayerRace> = {
    metalMine: 'humans',
    mineralRefinery: 'robots',
    gasPlant: 'axons',
    solarPlant: 'humans',
    fusionPlant: 'robots',
    hangars: 'axons',
    shipyard: 'humans',
    laboratory: 'robots',
    techCenter: 'axons',
    government: 'humans',
    robotFactory: 'robots',
    automationCenter: 'axons',
    metalStorage: 'humans',
    mineralStorage: 'robots',
    gasStorage: 'axons',
    recyclingPlant: 'humans',
    tradeCenter: 'robots',
};
